/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntCalculationDataTransferObject } from './IntCalculationDataTransferObject';
import {
    IntCalculationDataTransferObjectFromJSON,
    IntCalculationDataTransferObjectFromJSONTyped,
    IntCalculationDataTransferObjectToJSON,
    IntCalculationDataTransferObjectToJSONTyped,
} from './IntCalculationDataTransferObject';
import type { MoneyCalculationDataTransferObject } from './MoneyCalculationDataTransferObject';
import {
    MoneyCalculationDataTransferObjectFromJSON,
    MoneyCalculationDataTransferObjectFromJSONTyped,
    MoneyCalculationDataTransferObjectToJSON,
    MoneyCalculationDataTransferObjectToJSONTyped,
} from './MoneyCalculationDataTransferObject';

/**
 * 
 * @export
 * @interface BasicShopStatistics
 */
export interface BasicShopStatistics {
    /**
     * 
     * @type {string}
     * @memberof BasicShopStatistics
     */
    currentSince?: string;
    /**
     * 
     * @type {string}
     * @memberof BasicShopStatistics
     */
    currentUntil?: string;
    /**
     * 
     * @type {string}
     * @memberof BasicShopStatistics
     */
    previousSince?: string;
    /**
     * 
     * @type {string}
     * @memberof BasicShopStatistics
     */
    previousUntil?: string;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    turnoverNet?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    turnoverGross?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    spendGoodsNet?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    spendGoodsGross?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    spendMarketing?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {IntCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    orderAmountNet?: IntCalculationDataTransferObject;
    /**
     * 
     * @type {IntCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    orderAmountGross?: IntCalculationDataTransferObject;
    /**
     * 
     * @type {IntCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    pnoNet?: IntCalculationDataTransferObject;
    /**
     * 
     * @type {IntCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    pnoGross?: IntCalculationDataTransferObject;
    /**
     * 
     * @type {IntCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    averageOrderValueNet?: IntCalculationDataTransferObject;
    /**
     * 
     * @type {IntCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    averageOrderValueGross?: IntCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    gainNet?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    gainGross?: MoneyCalculationDataTransferObject;
}

/**
 * Check if a given object implements the BasicShopStatistics interface.
 */
export function instanceOfBasicShopStatistics(value: object): value is BasicShopStatistics {
    return true;
}

export function BasicShopStatisticsFromJSON(json: any): BasicShopStatistics {
    return BasicShopStatisticsFromJSONTyped(json, false);
}

export function BasicShopStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasicShopStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'currentSince': json['currentSince'] == null ? undefined : json['currentSince'],
        'currentUntil': json['currentUntil'] == null ? undefined : json['currentUntil'],
        'previousSince': json['previousSince'] == null ? undefined : json['previousSince'],
        'previousUntil': json['previousUntil'] == null ? undefined : json['previousUntil'],
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['turnoverGross']),
        'spendGoodsNet': json['spendGoodsNet'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['spendGoodsNet']),
        'spendGoodsGross': json['spendGoodsGross'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['spendGoodsGross']),
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['spendMarketing']),
        'orderAmountNet': json['orderAmountNet'] == null ? undefined : IntCalculationDataTransferObjectFromJSON(json['orderAmountNet']),
        'orderAmountGross': json['orderAmountGross'] == null ? undefined : IntCalculationDataTransferObjectFromJSON(json['orderAmountGross']),
        'pnoNet': json['pnoNet'] == null ? undefined : IntCalculationDataTransferObjectFromJSON(json['pnoNet']),
        'pnoGross': json['pnoGross'] == null ? undefined : IntCalculationDataTransferObjectFromJSON(json['pnoGross']),
        'averageOrderValueNet': json['averageOrderValueNet'] == null ? undefined : IntCalculationDataTransferObjectFromJSON(json['averageOrderValueNet']),
        'averageOrderValueGross': json['averageOrderValueGross'] == null ? undefined : IntCalculationDataTransferObjectFromJSON(json['averageOrderValueGross']),
        'gainNet': json['gainNet'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['gainNet']),
        'gainGross': json['gainGross'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['gainGross']),
    };
}

export function BasicShopStatisticsToJSON(json: any): BasicShopStatistics {
    return BasicShopStatisticsToJSONTyped(json, false);
}

export function BasicShopStatisticsToJSONTyped(value?: BasicShopStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentSince': value['currentSince'],
        'currentUntil': value['currentUntil'],
        'previousSince': value['previousSince'],
        'previousUntil': value['previousUntil'],
        'turnoverNet': MoneyCalculationDataTransferObjectToJSON(value['turnoverNet']),
        'turnoverGross': MoneyCalculationDataTransferObjectToJSON(value['turnoverGross']),
        'spendGoodsNet': MoneyCalculationDataTransferObjectToJSON(value['spendGoodsNet']),
        'spendGoodsGross': MoneyCalculationDataTransferObjectToJSON(value['spendGoodsGross']),
        'spendMarketing': MoneyCalculationDataTransferObjectToJSON(value['spendMarketing']),
        'orderAmountNet': IntCalculationDataTransferObjectToJSON(value['orderAmountNet']),
        'orderAmountGross': IntCalculationDataTransferObjectToJSON(value['orderAmountGross']),
        'pnoNet': IntCalculationDataTransferObjectToJSON(value['pnoNet']),
        'pnoGross': IntCalculationDataTransferObjectToJSON(value['pnoGross']),
        'averageOrderValueNet': IntCalculationDataTransferObjectToJSON(value['averageOrderValueNet']),
        'averageOrderValueGross': IntCalculationDataTransferObjectToJSON(value['averageOrderValueGross']),
        'gainNet': MoneyCalculationDataTransferObjectToJSON(value['gainNet']),
        'gainGross': MoneyCalculationDataTransferObjectToJSON(value['gainGross']),
    };
}

